import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import vuetify from "./plugins/vuetify";
import i18n from './i18n'
import axios from 'axios'
import brandingJson from './assets/Branding/vuetify.branding.json'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

// Accessibility imports
import '@/assets/styles/accessibility.css';
import screenReaderService from '@/services/screenReaderService';
import keyboardShortcuts from '@/utils/keyboardShortcuts';
import { FocusTrapDirective, AutoFocusDirective } from '@/utils/focusManagement';

Vue.component('vue-phone-number-input', VuePhoneNumberInput);

Vue.config.productionTip = false;

// Register accessibility services
Vue.use(screenReaderService);
Vue.use(keyboardShortcuts);

// Register accessibility directives
Vue.directive('focus-trap', FocusTrapDirective);
Vue.directive('auto-focus', AutoFocusDirective);

// Global filter for format menu text based on titleCase branding setting
Vue.filter('formatMenuText', function (text) {
    if (!text) return text;

    // Check the titleCase setting from the current experience
    const titleCase = Vue.prototype.$experience?.titleCase !== false; // default to true if not set

    if (titleCase) {
        // Title case: capitalize first letter of all words
        return text.split(' ').map(word => {
            if (word.length === 0) return word;
            // Check if word is an acronym (all uppercase)
            if (word === word.toUpperCase() && word.length > 1) {
                return word; // Keep acronyms as-is
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
    } else {
        // Sentence case: only capitalize first letter of first word
        // But preserve acronyms
        const words = text.split(' ');
        return words.map((word, index) => {
            if (word.length === 0) return word;
            // Check if word is an acronym (all uppercase)
            if (word === word.toUpperCase() && word.length > 1) {
                return word; // Keep acronyms as-is
            }
            if (index === 0) {
                // First word: capitalize first letter
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            } else {
                // Other words: all lowercase
                return word.toLowerCase();
            }
        }).join(' ');
    }
});

//Global variables
Vue.prototype.$baseUrl = globalThis.location.protocol + "//" + globalThis.location.host;
Vue.prototype.$experience = brandingJson[0];
Vue.prototype.$hasonboarding = false;

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login','/register','/forgotPassword','/resetPassword'];
    const authRequired = !publicPages.includes(to.path);
    let loggedIn = localStorage.getItem('user');
    if (authRequired && !loggedIn) {
        return next('/login');
    }
    let user = JSON.parse(loggedIn);
    if (user?.mfa === true && to.path !== '/mfaCodeValidation') {
        if (authRequired)
            return next('/mfaCodeValidation');
    }
    next();
});

// Page title and accessibility management
router.afterEach((to) => {
    // Set page title based on route name
    const pageTitles = {
        'home': 'Dashboard',
        'login': 'Login',
        'mfaCodeValidation': 'MFA Validation',
        'register': 'Register',
        'forgotPassword': 'Forgot Password',
        'resetPassword': 'Reset Password',
        'userManagement': 'User Management',
        'reports': 'Reports',
        'faq': 'FAQ'
    };

    const appTitle = Vue.prototype.$experience?.appTitle || 'Vault';
    const pageTitle = pageTitles[to.name] || appTitle;
    document.title = `${pageTitle} - ${appTitle}`;

    // Set document language
    const currentLocale = i18n.locale || 'en';
    document.documentElement.setAttribute('lang', currentLocale);

    // Announce page navigation to screen readers (after a short delay to ensure page is loaded)
    Vue.nextTick(() => {
        setTimeout(() => {
            if (Vue.prototype.$announcer) {
                Vue.prototype.$announcer.announceNavigation(pageTitle);
            }
        }, 100);
    });
});
let proxy = axios.create();

proxy.interceptors.response.use((response) => response, (error) => {
    // V�rifie si la session est expir�e (401)
    const status = error.response ? error.response.status : null;
    if ((status === 401 || status === 419) && router.currentRoute.name !== 'login') {
        router.push({ name: 'login' });
    }
    return Promise.reject(error);
});

Vue.use({
    install(Vue) {
        Vue.prototype.$axios = proxy;
    }
})


new Vue({
    vuetify,
    i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
